import EditBtn from './EditBtn'
import AddMod from './Modal'  
import './style.css'
import React, {useState, useEffect} from 'react';
import Pagination from '../components/Pagination';
import { fetchRegions } from './../service/regions/comp';
// import { fetchTypes } from '../service/types/comp';
const columns = [
  { id: 'region_name', label: 'Name of Region' },
  { id: 'btn', label: '' }
];

const Packages = ({domain, selfRightsLvl, dataL, setDataL}) => {
    const [regs, setRegs] = useState(dataL);
    // const [name, setName] = useState('');

    // const [types, setTypes] = useState([]);

    // const getTypes = () => {
    //   fetchTypes(setTypes, domain);
    // } 
    const fetchList = () => {
      fetchRegions(setRegs, domain);
    }

    ////////////////
    // page loading 
    const [pageNumber, setPageNumber] = useState(0);
    
    const pageCount = Math.ceil(regs.length && regs.length / 10);
    const styler = (id) => {
      if (id === 'btn') return selfRightsLvl >= 64 ? {padding: 1.5, border: 0, width: '5%'} : {display: 'none'}
      else return {padding: 'auto'}
    }

    const displayData = regs && regs.slice(pageNumber * 10, pageNumber * 10 + 10).map(row => {
        const index = regs.indexOf(row); 
        return ( 
        <tr key={row.id}>
        {columns.map(column => 
          <td key={column.id} style={styler(column.id)}> 
            {
              column.id !== 'btn' ?
                (row[column.id] !== '' ?
                  row[column.id] 
                : 
                  'None'
                ) 
              : 
                <EditBtn 
                fetchAgain={fetchList}
                // countries={regs.packs[index].countries} 
                domain={domain} 
                id={regs[index]?.region_id}
                nameL={regs[index]?.region_name}
                // type={regs.packs[index].type}
                // types={types}
                // fetchTypesAgain={setTypes}
                // price={regs.packs[index].price}
                />
            }
          </td>
        )}
      </tr>
    )});

    ////////////////
    // actions
    // const fillForms = (e) => {
    //   setName(e.target.value);
    // }
    // useEffect(() =>{
    //   fetchList();
    // }, [pageNumber])

    useEffect(() =>{
      setDataL(regs);
    }, [regs])

    return(
      <div className="packages box"> 
        {/* <input type="text" className='textField' placeholder='Find by name' onChange={fillForms}/> */}
        {/* <button 
        onClick={fetchList} 
        className='requestBtn'>Get Filtered list</button> */}
        <button 
        onClick={fetchList} 
        className='closeBtn'>Refresh</button>
        <div className='op-table'>
          <table>
            <thead>
              <tr>
                {columns.map(column => 
                  <th key={column.id} style={styler(column.id)}>
                    {column.label}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {displayData}
            </tbody>
          </table>
          <Pagination pageNumber={pageNumber} pageCount={pageCount} setPageNumber={setPageNumber}/> 
        </div>
        <AddMod selfRightsLvl={selfRightsLvl} fetchAgain={fetchList} domain={domain} />
        {/* types={types} fetchTypesAgain={setTypes} */}
      </div>
    )
}
export default Packages;